export default __webpack_public_path__ + "static/media/uk.9d71b5bb.svg";